import { render } from "./EvidenceFrequencyGraph.vue?vue&type=template&id=0289a60a&ts=true"
import script from "./EvidenceFrequencyGraph.vue?vue&type=script&lang=ts"
export * from "./EvidenceFrequencyGraph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__